/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllTenants } from '../fn/tenant/get-all-tenants';
import { GetAllTenants$Params } from '../fn/tenant/get-all-tenants';
import { getTenantByAbbreviation } from '../fn/tenant/get-tenant-by-abbreviation';
import { GetTenantByAbbreviation$Params } from '../fn/tenant/get-tenant-by-abbreviation';
import { TenantDto as SecurityTenantDto } from '../models/security/tenant-dto';

@Injectable({ providedIn: 'root' })
export class TenantClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tenantGetAllTenants()` */
  static readonly TenantGetAllTenantsPath = '/tenant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTenants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTenants$Response(context?: HttpContext): Observable<StrictHttpResponse<Array<SecurityTenantDto>>> {
    const obs = getAllTenants(this.http, this.rootUrl, {} satisfies GetAllTenants$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTenants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTenants(context?: HttpContext): Observable<Array<SecurityTenantDto>> {
    const resp = this.getAllTenants$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SecurityTenantDto>>): Array<SecurityTenantDto> => r.body)
    );
  }

  /** Path part for operation `tenantGetTenantByAbbreviation()` */
  static readonly TenantGetTenantByAbbreviationPath = '/tenant/{abbreviation}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantByAbbreviation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantByAbbreviation$Response(abbreviation: string, context?: HttpContext): Observable<StrictHttpResponse<SecurityTenantDto | undefined>> {
    const obs = getTenantByAbbreviation(this.http, this.rootUrl, { abbreviation } satisfies GetTenantByAbbreviation$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantByAbbreviation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantByAbbreviation(abbreviation: string, context?: HttpContext): Observable<SecurityTenantDto | undefined> {
    const resp = this.getTenantByAbbreviation$Response(abbreviation, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SecurityTenantDto | undefined>): SecurityTenantDto | undefined => r.body)
    );
  }

}
